// extracted by mini-css-extract-plugin
export default {"header":"UserUploads_header__flBB0","videoContent":"UserUploads_videoContent__5JXUn","card":"UserUploads_card__omHDW"};